import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn';
import { ChevronDown } from 'lucide-react';
interface SelectOption {
  value: string;
  label: string;
}
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: SelectOption[];
  error?: string;
}
export const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  className,
  label,
  options,
  error,
  ...props
}, ref) => {
  return <div className="w-full space-y-1.5" data-id="element-295">
        {label && <label className="text-sm font-medium leading-none text-slate-700" data-id="element-296">
            {label}
          </label>}
        <div className="relative" data-id="element-297">
          <select className={cn('flex h-10 w-full appearance-none rounded-md border border-slate-200 bg-white px-3 py-2 text-sm ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 disabled:cursor-not-allowed disabled:opacity-50', error && 'border-red-500', className)} ref={ref} {...props} data-id="element-298">
            {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-299">
                {opt.label}
              </option>)}
          </select>
          <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400 pointer-events-none" data-id="element-300" />
        </div>
        {error && <p className="text-xs text-red-500" data-id="element-301">{error}</p>}
      </div>;
});
Select.displayName = 'Select';